// --------------------------------------------------------
// src/views/pagination.view.js
//
// Manage the view/template of the pagination filter
//
// --------------------------------------------------------
"use strict";

const PAGINATION_TEMPLATE = `
<% if(this.collection.length > 12) { %>
	<ul class="reads-pagination">
		<% if(currentPage != 1) { %>
			<li class="prev"><a class="prev" aria-label="Previous"><span aria-hidden="true"><i class="fa fa-angle-left fa-3x" aria-hidden="true"></i></span></a></li>
		<% } else { %>
			<li class="prev" style="opacity: 0; visibility: hidden"><a class="prev" aria-label="Previous"><span aria-hidden="true"><i class="fa fa-angle-left fa-3x" aria-hidden="true"></i></span></a></li>
		<% } %>
		<% for(var p = 0; p < items.length; p++) { %>
			<% if (items[p] === "...") { %>
				<li class="disabled"><span class="page"><%= items[p] %></span></li>
			<% } else { %>
				<% if (currentPage == items[p]) { %>
					<li class="active"><a href="#<%= app.getLanguage() %>/books/<%= items[p] %>" class="page"><%= items[p] %></a></li>
				<% } else { %>
					<li class=""><a href="#<%= app.getLanguage() %>/books/<%= items[p] %>" class="page"><%= items[p] %></a></li>
				<% }%>
			<% } %>
		<% } %>
		<% if(currentPage != totalPages) { %>
			<li class="next"><a class="next" aria-label="Next"><span aria-hidden="true"><i class="fa fa-angle-right fa-3x" aria-hidden="true"></i></span></a></li>
		<% } else { %>
			<li class="next" style="opacity:0; visibility: hidden;"><a class="next" aria-label="Next"><span aria-hidden="true"><i class="fa fa-angle-right fa-3x" aria-hidden="true"></i></span></a></li>
		<% } %>
	</ul>
<% } %>
`;

// The view for a single book model
const PaginationComponent = Backbone.View.extend({
	// The number of elements displayed in one page
	perPage: 12,
	// The current page
	currentPage: 1,
	// The total pages available
	totalPages: 1,
	// Contains the pagination strings
	items: [],
	// The offset, number of pagination elements displayed
	offset: 7,

	// Bind events listeners
	events: {
		"click a.prev": "goToPrev",
		"click a.next": "goToNext",
		"click a.page": "goToPage"
	},

	// The DOM element that will be created
	tagName: "nav",

	// Convert the template to HTML
	template:_.template( PAGINATION_TEMPLATE ),

	// Initialize the pagination view
	initialize: function() {
		// has to be called outside of this function for the re-render function to work properly
		// otherwise we duplicate the listener below
		this.initParams();

		this.listenTo(this.collection, "update reset destroy", this.reRender);
	},

	// Initialize the pagination specific variables
	initParams: function() {
		if (this.collection) {
			this.currentPage = 1;
			this.totalPages = Math.ceil(this.collection.length / this.collection.perPage);
		}
	},

	// Get the items that will be displayed on the pagination
	getItems: function() {
		var left, right, even, maxLength;

		maxLength = this.offset;

		even = maxLength % 2 === 0 ? 1 : 0;
		left = Math.floor(maxLength / 2);
		right = this.totalPages - left + 1 + even;

		if (this.currentPage >= left && this.currentPage <= right) {
			var start, end;

			start = this.currentPage - left + 2;
			end = this.currentPage + left - 2 - even;

			return [1, "...", ...this.range(start, end), "...", this.totalPages];
		} else if (maxLength < this.totalPages) {
			return [
				...this.range(1, left),
				"...",
				...this.range(this.totalPages - left + 1 + even, this.totalPages)
			];
		} else {
			return this.range(1, this.totalPages);
		}
	},

	// Display the content of a specific page
	goTo: function(page) {

		this.currentPage = Number(page);

		var paginationEvent = new CustomEvent("page", {
			bubbles: true,
			detail: {
				page: () => this.currentPage,
				collection: () => this.paginate()
			}
		});
		this.el.dispatchEvent(paginationEvent);

		this.render();
	},

	// Display the content of the previous page
	goToPrev: function(e) {
		e.preventDefault();
		var page = parseInt(this.currentPage) - 1;
		this.goTo(page);
	},

	// Display the content of the following page
	goToNext: function(e) {
		e.preventDefault();
		var page = parseInt(this.currentPage) + 1;
		this.goTo(page);
	},

	// Display the content of a specific page
	goToPage: function(e) {
		e.preventDefault();
		var page = parseInt($(e.target).text());
		this.goTo(page);
	},

	paginate: function() {
		if (this.currentPage === 0) {
			return this.collection.first(this.perPage);
		}
		// Return the rest of the 12 (perPage) first elements of the collection from a specific index (perPage * page)
		return this.collection.rest(this.perPage * (this.currentPage - 1))
						 .slice(0, this.perPage);
	},

	// Create an array of ascending integers from a beginning to the end
	range: function(from, to) {
		var range = [];

		from = from > 0 ? from : 0;

		for (from; from <= to; from++) {
			range.push(from);
		}

		return range;
	},

	// Render the template
	render: function() {
		this.items = this.getItems();
		var paginationTemplate = this.template(this);
		this.$el.html(paginationTemplate);

		return this;
	},

	// Not pretty but reinitializes the parameters before rendering the page
	reRender: function() {
		this.initParams();
		this.render();
	},

});
